import { Pipe, PipeTransform } from '@angular/core';
import { Header, HeaderTunnel } from '@components/header/models';

@Pipe({ name: 'isHeaderTunnel', standalone: true })
export class IsHeaderTunnelPipe implements PipeTransform {
  transform(value: Header): value is HeaderTunnel {
    return value.type === 'tunnel';
  }
}
